
import { Options, Vue } from "vue-class-component";
// import HelloWorld from "@/components/HelloWorld.vue"; // @ is an alias to /src
@Options({
    components: {
        // HelloWorld,
    },
})
export default class Index extends Vue {
    [k: string]: any;
    private userData: any = { roleId: 0, avatar: '', nickname: '', roleType: '' }; // 用户数据
    private isMenuCollapse: boolean = false; // 左侧菜单栏展开/收起控制
    private menuList: Array<object> = []; // 左侧栏目
    private menuActive: any = ''; // 菜单默认选中项
    private menuOpened: Array<string> = []; // 菜单默认展开项
    private settingVisible: boolean = false; // 系统设置
    beforeCreate() {}
    created() {
        this.getUserData();
        this.getMenuList();
        this.getPageParams();
    }
    mounted() {}
    private getUserData(): void {
        let data: any = window.sessionStorage.getItem("_USER_DATA_");
        data && this.$m.vuex('userData', JSON.parse(data));
        this.$axios.get(this.baseUrl, {
            params: {
                r: this.$getApis.userInfo,
            }
        }).then((res: any) => {
            console.log('getUserData>>>', res);
            if(res.code == 0) {
                let {role, user}: any = res.data; 
                if(user.roleid == 1) {
                    this.userData.roleId = 1;
                    this.userData.nickname = 'admin';
                    this.userData.avatar = 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png';
                } else {
                    this.userData.roleId = user.id;
                    this.userData.nickname = user.nickname;
                    if(['bank_user', 'zhi_user', 'servicer_user'].indexOf(user.user) >= 0) {
                        this.userData.avatar = role.logo ? this.$cm.jointPicUrl(role.logo) : 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png';
                    } else {
                        this.userData.avatar = role.pic ? this.$cm.jointPicUrl(role.pic) : 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png';
                    }
                    
                }
                this.userData.roleType = user.user;
                this.$m.vuex('userData', this.userData);
            }
        });
    }
    private getMenuList(): void {
        this.$axios.get(this.baseUrl, {
            params: {
                r: this.$getApis.menuList,
                is_menu: 1
            }
        }).then((res: any) => {
            // console.log('menuList>>>', res);
            if(res.code == 0) {
                let list: Array<object> = res.data.menus;
                this.menuList = list;
                // console.log('menuList>>>', this.menuList);
            }
        });
    }
    private getPageParams(): void {
        let data: string | null = window.sessionStorage.getItem("_MENU_ACTIVE_");
        if(data) {
            let _data: any = JSON.parse(data);
            this.menuActive = _data.active;
            this.menuOpened = _data.opened;
            // this.handleMenuSelect(_data.active, _data.opened);
        }
    }
    public handleMenuSelect(path: string, pathList: Array<string>): void {
        let params: Array<string> = path.split('?'), 
            paramsList: Array<string> = params.length > 1 ? params[1].split('&') : [],
            query: any = new Object;
        if(paramsList.length > 0) {
            paramsList.forEach((el: any) => {
                let kv: Array<string> = el.split('=');
                query[kv[0]] = kv[1];
            });
        }
        this.menuActive = path;
        this.menuOpened = pathList;
        this.$router.push({ path: '/' + path, query: query });
        this.setPageParams();
    }
    public handleCommandClick(command: string): void {
        console.log('command>>>', command);
        switch (command) {
            case 'welcome':
                this.menuActive = '';
                this.menuOpened = [];
                this.$router.push({ path: '/' });
                this.setPageParams();
                break;
            case 'changePwd':
                this.$router.push({ path: '/changepwd' });
                break;
            case 'logout':
                this.logOut();
                break;
            default:
                break;
        }
    }
    private logOut(): void {
        window.localStorage.setItem('_TOKEN_', '');
        window.sessionStorage.clear();
        this.$router.push({ path: "/login" });
    }
    private setPageParams(): void {
        let data: Object = {
            active: this.menuActive,
            opened: this.menuOpened
        };
        window.sessionStorage.setItem('_MENU_ACTIVE_', JSON.stringify(data));
    }
    public toP2ipoWeb(): void {
        window.open('https://www.p2ipo.com', '_blank');
    }
    public handleSeetingClick(): void {
        this.settingVisible = true;
        this.$router.push({ path: '/setting/menu/index' });
    }
    public clear() {
        this.$axios.get('https://frontend.p2ipo.com/index.php', {
            params: {
                r: 'site/flush-cache'
            }
        }).then((res: any) => {
            console.log('clearStorage>>>', res);
            if(res.code == 0) {
                this.$message.success(res.message);
            } else {
                this.$message.error(res.message);
            }
        });
    }
}
